import React from "react";
import { Box, Typography, SxProps, Theme } from "@mui/material";
import Icons from "@/assets";

interface RequiredErrorBadgeProps {
  sx?: SxProps<Theme>;
}

const RequiredErrorBadge: React.FC<RequiredErrorBadgeProps> = ({ sx }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "2.43vw", sm: 10 },
          color: "#f44336",
          mr: "3%",
        }}
      >
        Required
      </Typography>
      <Box
        component="img"
        src={Icons.Alert}
        sx={{
          height: { xs: "2.91vw", sm: 12 },
          width: { xs: "2.91vw", sm: 12 },
        }}
      />
    </Box>
  );
};

export default RequiredErrorBadge;
